<template>
  <div>
    <div class="m-background m-background--media-2"></div>
    <div id="reset-wrapper"><a @click="showConfirm = true"><img src="../../assets/images/icons/home.png" class="full-logo"></a></div>
    <ConfirmReset v-if="showConfirm" @close="showConfirm = false"></ConfirmReset>
    <div class="l-container">
      <div id="nav">
        <h2>Welcome!</h2>
        <p> Enter and explore the rooms, click on the hotspots to find out more!</p>
        <router-link :to="{ name: 'communual-area' }"><div class="m-btn m-btn__primary room1">Communal Area &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></div></router-link>
        <router-link :to="{ name: 'bedroom' }"><div class="m-btn m-btn__primary room2">Bedroom &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></div></router-link>
        <router-link :to="{ name: 'kitchen' }"><div class="m-btn m-btn__primary room3">Kitchen &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></div></router-link>
      </div>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import Brand from '../../components/Brand'
import MainFooter from '../../components/MainFooter'
import ConfirmReset from '../../components/ConfirmReset'

export default {
  data () {
    return {
      showConfirm: false
    }
  },
  components: {
    Brand,
    MainFooter,
    ConfirmReset
  },
  name: 'Reception'
}
</script>

<style scoped lang="scss">
.intro {
  right: 0;
  top:0;
  margin-top: 240px;
  margin-right: 120px;
  position: absolute;
  background: rgba(255, 255, 255, 0.95  );
  width: 46%;
  padding: 50px 40px;
  font-size: 1.6rem;
  text-transform: uppercase;
  border-radius: 10px;
}
.m-btn {
  background: #fff;
  &:hover {
    background: #f2f2f2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rooms/Reception.vue